import React, { useState } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import AnimatedModal from './AnimatedModal';
import ModalHelp from '../../../components/ModalHelp';

interface FinalizarProcessoModalProps {
  show: boolean;
  processo: any;
  onClose: () => void;
  onConfirm: (processoId: string) => Promise<void>;
}

const FinalizarProcessoModal: React.FC<FinalizarProcessoModalProps> = ({
  show,
  processo,
  onClose,
  onConfirm
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(processo.id);
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatedModal isOpen={show} onClose={onClose}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        minWidth: '500px',
        maxWidth: '600px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}>
        <div className="modal-header" style={{
          borderBottom: '1px solid #e9ecef',
          paddingBottom: '16px',
          marginBottom: '20px'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>Finalizar Processo</h3>
          <button onClick={onClose} style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#6c757d'
          }}>×</button>
        </div>
        
        <div className="modal-body">
          <div style={{ textAlign: 'center', color: '#dc3545', marginBottom: '20px' }}>
            <FaExclamationTriangle size={48} />
          </div>

          <p style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px' }}>
            Esta ação é irreversível! Ao confirmar:
          </p>

          <div style={{ 
            backgroundColor: '#f8f9fa', 
            border: '1px solid #dee2e6', 
            borderRadius: '8px', 
            padding: '15px', 
            marginBottom: '20px' 
          }}>
            <div style={{ marginBottom: '10px' }}>
              O Processo <strong>{processo?.nome} ({processo?.identificador})</strong> será marcado como <strong>FINALIZADO</strong>
            </div>
            <div>
              <strong>Nenhuma modificação</strong> poderá ser feita posteriormente neste Processo depois de sua finalização.
            </div>
          </div>

          <p style={{ color: '#6c757d', fontSize: '14px', textAlign: 'center' }}>
            Você tem certeza que deseja prosseguir?
          </p>
        </div>

        <div className="modal-footer" style={{
          borderTop: '1px solid #e9ecef',
          paddingTop: '16px',
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px'
        }}>
          <button 
            onClick={onClose} 
            disabled={isSubmitting}
            style={{
              padding: '8px 16px',
              border: '1px solid #6c757d',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#6c757d',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            Cancelar
          </button>
          <button 
            onClick={handleConfirm}
            disabled={isSubmitting}
            style={{
              padding: '8px 16px',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              backgroundColor: isSubmitting ? '#6c757d' : '#dc3545',
              color: 'white',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            {isSubmitting ? 'Finalizando...' : 'Confirmar Finalização'}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default FinalizarProcessoModal;